import * as firebase from 'firebase';
import "firebase/database"
const firebaseConfig = {
    apiKey: "AIzaSyDIHPzB9Pvbmv-4zxAaPLsiZhOfdcvGRYs",
    authDomain: "hl-team-ller.firebaseapp.com",
    databaseURL: "https://hl-team-ller.firebaseio.com",
    projectId: "hl-team-ller",
    storageBucket: "hl-team-ller.appspot.com",
    messagingSenderId: "340218310883",
    appId: "1:340218310883:web:4f12eb399d202a115455d6",
    measurementId: "G-03RYHEPFF1"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.database();